import { render, staticRenderFns } from "./StatusBox.vue?vue&type=template&id=48744d9e&"
import script from "./StatusBox.vue?vue&type=script&lang=js&"
export * from "./StatusBox.vue?vue&type=script&lang=js&"
import style0 from "./StatusBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports